import threeD from './3d.svg';
import threeDMove from './3d-move.svg';
import threeSixty from './360.svg';
import accessibility from './accessibility.svg';
import ad from './ad.svg';
import adGroup from './ad-group.svg';
import add from './add.svg';
import addCircle from './add-circle.svg';
import addLayout from './add-layout.svg';
import addPin from './add-pin.svg';
import addSection from './add-section.svg';
import adsOverview from './ads-overview.svg';
import adsStats from './ads-stats.svg';
import alert from './alert.svg';
import alignBottom from './align-bottom.svg';
import alignBottomCenter from './align-bottom-center.svg';
import alignBottomLeft from './align-bottom-left.svg';
import alignBottomRight from './align-bottom-right.svg';
import alignMiddle from './align-middle.svg';
import alignTop from './align-top.svg';
import alignTopCenter from './align-top-center.svg';
import alignTopLeft from './align-top-left.svg';
import alignTopRight from './align-top-right.svg';
import alphabetical from './alphabetical.svg';
import amazon from './amazon.svg';
import androidShare from './android-share.svg';
import angledPin from './angled-pin.svg';
import animate from './animate.svg';
import api from './api.svg';
import apple from './apple.svg';
import apps from './apps.svg';
import arTryOn from './ar-try-on.svg';
import arrowBack from './arrow-back.svg';
import arrowCircleBack from './arrow-circle-back.svg';
import arrowCircleDown from './arrow-circle-down.svg';
import arrowCircleForward from './arrow-circle-forward.svg';
import arrowCircleUp from './arrow-circle-up.svg';
import arrowCounterClockwise from './arrow-counter-clockwise.svg';
import arrowDoubleBack from './arrow-double-back.svg';
import arrowDoubleForward from './arrow-double-forward.svg';
import arrowDown from './arrow-down.svg';
import arrowEnd from './arrow-end.svg';
import arrowForward from './arrow-forward.svg';
import arrowLeftCurved from './arrow-left-curved.svg';
import arrowNested from './arrow-nested.svg';
import arrowStart from './arrow-start.svg';
import arrowUp from './arrow-up.svg';
import arrowUpLeft from './arrow-up-left.svg';
import arrowUpRight from './arrow-up-right.svg';
import arrowsVertical from './arrows-vertical.svg';
import aspectRatio from './aspect-ratio.svg';
import audioBars from './audio-bars.svg';
import audioMix from './audio-mix.svg';
import audioPlaying from './audio-playing.svg';
import bell from './bell.svg';
import bellFill from './bell-fill.svg';
import birthdayCake from './birthday-cake.svg';
import blur from './blur.svg';
import board from './board.svg';
import boardStickerLarge from './board-sticker-large.svg';
import boardStickerSmall from './board-sticker-small.svg';
import bold from './bold.svg';
import border from './border.svg';
import borderShadow from './border-shadow.svg';
import briefcase from './briefcase.svg';
import buildingBusiness from './building-business.svg';
import businessHierarchy from './business-hierarchy.svg';
import calendar from './calendar.svg';
import calendarCheck from './calendar-check.svg';
import camera from './camera.svg';
import cameraFlip from './camera-flip.svg';
import cameraRoll from './camera-roll.svg';
import cancel from './cancel.svg';
import canonicalPin from './canonical-pin.svg';
import captions from './captions.svg';
import captionsOutline from './captions-outline.svg';
import cardStack from './card-stack.svg';
import cardStackRefresh from './card-stack-refresh.svg';
import check from './check.svg';
import checkCircle from './check-circle.svg';
import checkCircleFill from './check-circle-fill.svg';
import chevronDownCircle from './chevron-down-circle.svg';
import chevronLeftCircle from './chevron-left-circle.svg';
import chevronRightCircle from './chevron-right-circle.svg';
import chevronUpCircle from './chevron-up-circle.svg';
import circle from './circle.svg';
import circleEllipsis from './circle-ellipsis.svg';
import circleInformationFill from './circle-information-fill.svg';
import circleInitializing from './circle-initializing.svg';
import clear from './clear.svg';
import clipboard from './clipboard.svg';
import clips from './clips.svg';
import clock from './clock.svg';
import clockChecked from './clock-checked.svg';
import cloudServer from './cloud-server.svg';
import code from './code.svg';
import codeCheck from './code-check.svg';
import cog from './cog.svg';
import cogFill from './cog-fill.svg';
import collage from './collage.svg';
import collapse from './collapse.svg';
import color from './color.svg';
import colorPalette from './color-palette.svg';
import colorPicker from './color-picker.svg';
import colorSolid from './color-solid.svg';
import colorSplit from './color-split.svg';
import compass from './compass.svg';
import compassFill from './compass-fill.svg';
import compose from './compose.svg';
import contrast from './contrast.svg';
import conversionTag from './conversion-tag.svg';
import copyToClipboard from './copy-to-clipboard.svg';
import creditCard from './credit-card.svg';
import creditCardPlus from './credit-card-plus.svg';
import crop from './crop.svg';
import crystalBall from './crystal-ball.svg';
import cutout from './cutout.svg';
import dash from './dash.svg';
import dataSource from './data-source.svg';
import deselect from './deselect.svg';
import design from './design.svg';
import desktop from './desktop.svg';
import diagnostics from './diagnostics.svg';
import directionalArrowLeft from './directional-arrow-left.svg';
import directionalArrowRight from './directional-arrow-right.svg';
import download from './download.svg';
import dragDrop from './drag-drop.svg';
import draw from './draw.svg';
import dropbox from './dropbox.svg';
import duplicate from './duplicate.svg';
import edit from './edit.svg';
import ellipsis from './ellipsis.svg';
import envelope from './envelope.svg';
import erase from './erase.svg';
import eraseAuto from './erase-auto.svg';
import etsy from './etsy.svg';
import expand from './expand.svg';
import eye from './eye.svg';
import eyeHide from './eye-hide.svg';
import faceHappy from './face-happy.svg';
import faceNeutral from './face-neutral.svg';
import faceSad from './face-sad.svg';
import faceSmiley from './face-smiley.svg';
import faceSmileyOutline from './face-smiley-outline.svg';
import faceSmileyPlus from './face-smiley-plus.svg';
import faceTryon from './face-tryon.svg';
import facebook from './facebook.svg';
import fade from './fade.svg';
import ferrisWheel from './ferris-wheel.svg';
import fileBox from './file-box.svg';
import fileUnknown from './file-unknown.svg';
import fillOpaque from './fill-opaque.svg';
import fillTransparent from './fill-transparent.svg';
import filter from './filter.svg';
import flag from './flag.svg';
import flame from './flame.svg';
import flash from './flash.svg';
import flashAutomatic from './flash-automatic.svg';
import flashSlash from './flash-slash.svg';
import flashlight from './flashlight.svg';
import flipHorizontal from './flip-horizontal.svg';
import flipVertical from './flip-vertical.svg';
import folder from './folder.svg';
import folderFill from './folder-fill.svg';
import forward from './forward.svg';
import gauge from './gauge.svg';
import ghost from './ghost.svg';
import ghostFill from './ghost-fill.svg';
import gif from './gif.svg';
import gifVisual from './gif-visual.svg';
import gift from './gift.svg';
import globe from './globe.svg';
import globeChecked from './globe-checked.svg';
import gmail from './gmail.svg';
import graphBar from './graph-bar.svg';
import graphPie from './graph-pie.svg';
import hand from './hand.svg';
import handPointing from './hand-pointing.svg';
import handle from './handle.svg';
import heart from './heart.svg';
import heartBroken from './heart-broken.svg';
import heartHealth from './heart-health.svg';
import heartOutline from './heart-outline.svg';
import highlights from './highlights.svg';
import history from './history.svg';
import home from './home.svg';
import homeFill from './home-fill.svg';
import ideaPin from './idea-pin.svg';
import imagePortrait from './image-portrait.svg';
import imessage from './imessage.svg';
import impressum from './impressum.svg';
import indent from './indent.svg';
import infoCircle from './info-circle.svg';
import information from './information.svg';
import insightsAudience from './insights-audience.svg';
import insightsConversion from './insights-conversion.svg';
import instagram from './instagram.svg';
import instagramStories from './instagram-stories.svg';
import invoice from './invoice.svg';
import italics from './italics.svg';
import kakaoTalk from './kakao-talk.svg';
import key from './key.svg';
import knoop from './knoop.svg';
import labFlask from './lab-flask.svg';
import lassoMagic from './lasso-magic.svg';
import layersStack from './layers-stack.svg';
import layout from './layout.svg';
import lightbulb from './lightbulb.svg';
import lightningBoltCircle from './lightning-bolt-circle.svg';
import link from './link.svg';
import linkBroken from './link-broken.svg';
import lips from './lips.svg';
import listBullets from './list-bullets.svg';
import listNumbered from './list-numbered.svg';
import listNumberedRtl from './list-numbered-rtl.svg';
import location from './location.svg';
import lock from './lock.svg';
import logoLarge from './logo-large.svg';
import logoSmall from './logo-small.svg';
import logout from './logout.svg';
import magicPen from './magic-pen.svg';
import magicWand from './magic-wand.svg';
import magnifyingGlassSparkle from './magnifying-glass-sparkle.svg';
import manageAccess from './manage-access.svg';
import marginsLarge from './margins-large.svg';
import marginsMedium from './margins-medium.svg';
import marginsSmall from './margins-small.svg';
import maximize from './maximize.svg';
import megaphone from './megaphone.svg';
import menu from './menu.svg';
import messenger from './messenger.svg';
import microphone from './microphone.svg';
import minimize from './minimize.svg';
import mobile from './mobile.svg';
import moon from './moon.svg';
import movePin from './move-pin.svg';
import musicOff from './music-off.svg';
import musicOn from './music-on.svg';
import mute from './mute.svg';
import muteFill from './mute-fill.svg';
import orientationLandscape from './orientation-landscape.svg';
import orientationPortrait from './orientation-portrait.svg';
import outdent from './outdent.svg';
import outlook from './outlook.svg';
import overlayText from './overlay-text.svg';
import overlayTextOutline from './overlay-text-outline.svg';
import overview from './overview.svg';
import paperClip from './paper-clip.svg';
import paperLinesPlus from './paper-lines-plus.svg';
import pause from './pause.svg';
import pen from './pen.svg';
import penAuto from './pen-auto.svg';
import people from './people.svg';
import performancePlus from './performance-plus.svg';
import person from './person.svg';
import personAdd from './person-add.svg';
import personFill from './person-fill.svg';
import personMagnifyingGlass from './person-magnifying-glass.svg';
import phone from './phone.svg';
import pin from './pin.svg';
import pinHide from './pin-hide.svg';
import pincode from './pincode.svg';
import pinterest from './pinterest.svg';
import play from './play.svg';
import protect from './protect.svg';
import qrCode from './qr-code.svg';
import questionMark from './question-mark.svg';
import quote from './quote.svg';
import recordLimit from './record-limit.svg';
import recordLimit5 from './record-limit-5.svg';
import recordLimit10 from './record-limit-10.svg';
import recordLimit15 from './record-limit-15.svg';
import recordLimit30 from './record-limit-30.svg';
import recordLimit60 from './record-limit-60.svg';
import redo from './redo.svg';
import refresh from './refresh.svg';
import remove from './remove.svg';
import reorderImages from './reorder-images.svg';
import replace from './replace.svg';
import report from './report.svg';
import rewind from './rewind.svg';
import ribbon from './ribbon.svg';
import rocketship from './rocketship.svg';
import rotate from './rotate.svg';
import saturation from './saturation.svg';
import saveOutline from './save-outline.svg';
import saved from './saved.svg';
import scale from './scale.svg';
import scissors from './scissors.svg';
import search from './search.svg';
import searchByImage from './search-by-image.svg';
import searchFill from './search-fill.svg';
import security from './security.svg';
import select from './select.svg';
import send from './send.svg';
import shadows from './shadows.svg';
import shapes from './shapes.svg';
import share from './share.svg';
import shoppingBag from './shopping-bag.svg';
import shoppingBagFill from './shopping-bag-fill.svg';
import shrink from './shrink.svg';
import shuffles from './shuffles.svg';
import skintone from './skintone.svg';
import slide from './slide.svg';
import smiley from './smiley.svg';
import snapchat from './snapchat.svg';
import sortAscending from './sort-ascending.svg';
import sortDescending from './sort-descending.svg';
import sound from './sound.svg';
import soundFill from './sound-fill.svg';
import soundSlash from './sound-slash.svg';
import soundSlashFill from './sound-slash-fill.svg';
import sparkle from './sparkle.svg';
import speech from './speech.svg';
import speechEllipsis from './speech-ellipsis.svg';
import speechEllipsisFill from './speech-ellipsis-fill.svg';
import speechExclamationPoint from './speech-exclamation-point.svg';
import speechHeart from './speech-heart.svg';
import speechOutline from './speech-outline.svg';
import speed from './speed.svg';
import speedThirdX from './speed-.3x.svg';
import speedFifthX from './speed-.5x.svg';
import speed1X from './speed-1x.svg';
import speedDoubleX from './speed-2x.svg';
import speedTripleX from './speed-3x.svg';
import spread from './spread.svg';
import squarePlus from './square-plus.svg';
import squarePlusFill from './square-plus-fill.svg';
import star from './star.svg';
import starHalf from './star-half.svg';
import starOutline from './star-outline.svg';
import sticker from './sticker.svg';
import stickerImage from './sticker-image.svg';
import sun from './sun.svg';
import swap from './swap.svg';
import switchAccount from './switch-account.svg';
import table from './table.svg';
import tag from './tag.svg';
import tagStar from './tag-star.svg';
import target from './target.svg';
import telegram from './telegram.svg';
import template from './template.svg';
import terms from './terms.svg';
import text from './text.svg';
import textAlignCenter from './text-align-center.svg';
import textAlignLeft from './text-align-left.svg';
import textAlignRight from './text-align-right.svg';
import textAllCaps from './text-all-caps.svg';
import textExtraSmall from './text-extra-small.svg';
import textInvert from './text-invert.svg';
import textLarge from './text-large.svg';
import textLineHeight from './text-line-height.svg';
import textMedium from './text-medium.svg';
import textSentenceCase from './text-sentence-case.svg';
import textSize from './text-size.svg';
import textSmall from './text-small.svg';
import textSpacing from './text-spacing.svg';
import textSticker from './text-sticker.svg';
import threads from './threads.svg';
import thumbsDown from './thumbs-down.svg';
import thumbsUp from './thumbs-up.svg';
import timer from './timer.svg';
import timer3 from './timer-3.svg';
import timer10 from './timer-10.svg';
import tint from './tint.svg';
import trashCan from './trash-can.svg';
import trending from './trending.svg';
import underline from './underline.svg';
import undo from './undo.svg';
import unlock from './unlock.svg';
import uploadFeed from './upload-feed.svg';
import viber from './viber.svg';
import vibrance from './vibrance.svg';
import videoAdvance10Seconds from './video-advance-10-seconds.svg';
import videoCamera from './video-camera.svg';
import videoRewind10Seconds from './video-rewind-10-seconds.svg';
import viewTypeDefault from './view-type-default.svg';
import viewTypeDefaultFill from './view-type-default-fill.svg';
import viewTypeDense from './view-type-dense.svg';
import viewTypeList from './view-type-list.svg';
import viewTypeSparse from './view-type-sparse.svg';
import visit from './visit.svg';
import warmth from './warmth.svg';
import wave from './wave.svg';
import whatsapp from './whatsapp.svg';
import wifiNo from './wifi-no.svg';
import workflowStatusAll from './workflow-status-all.svg';
import workflowStatusCanceled from './workflow-status-canceled.svg';
import workflowStatusHalted from './workflow-status-halted.svg';
import workflowStatusInProgress from './workflow-status-in-progress.svg';
import workflowStatusOk from './workflow-status-ok.svg';
import workflowStatusProblem from './workflow-status-problem.svg';
import workflowStatusQueued from './workflow-status-queued.svg';
import workflowStatusUnstarted from './workflow-status-unstarted.svg';
import workflowStatusWarning from './workflow-status-warning.svg';
import xSocial from './x-social.svg';
import yahoo from './yahoo.svg';
import youtube from './youtube.svg';

const icons = Object.freeze({
  '360': threeSixty,
  '3d': threeD,
  '3d-move': threeDMove,
  'accessibility': accessibility,
  'ad': ad,
  'ad-group': adGroup,
  'add': add,
  'add-circle': addCircle,
  'add-layout': addLayout,
  'add-pin': addPin,
  'add-section': addSection,
  'ads-overview': adsOverview,
  'ads-stats': adsStats,
  'alert': alert,
  'align-bottom': alignBottom,
  'align-bottom-center': alignBottomCenter,
  'align-bottom-left': alignBottomLeft,
  'align-bottom-right': alignBottomRight,
  'align-middle': alignMiddle,
  'align-top': alignTop,
  'align-top-center': alignTopCenter,
  'align-top-left': alignTopLeft,
  'align-top-right': alignTopRight,
  'alphabetical': alphabetical,
  'amazon': amazon,
  'android-share': androidShare,
  'angled-pin': angledPin,
  'animate': animate,
  'api': api,
  'apple': apple,
  'apps': apps,
  'ar-try-on': arTryOn,
  'arrow-back': arrowBack,
  'arrow-circle-back': arrowCircleBack,
  'arrow-circle-down': arrowCircleDown,
  'arrow-circle-forward': arrowCircleForward,
  'arrow-circle-up': arrowCircleUp,
  'arrow-counter-clockwise': arrowCounterClockwise,
  'arrow-double-back': arrowDoubleBack,
  'arrow-double-forward': arrowDoubleForward,
  'arrow-down': arrowDown,
  'arrow-end': arrowEnd,
  'arrow-forward': arrowForward,
  'arrow-left-curved': arrowLeftCurved,
  'arrow-nested': arrowNested,
  'arrow-start': arrowStart,
  'arrow-up': arrowUp,
  'arrow-up-left': arrowUpLeft,
  'arrow-up-right': arrowUpRight,
  'arrows-vertical': arrowsVertical,
  'aspect-ratio': aspectRatio,
  'audio-bars': audioBars,
  'audio-mix': audioMix,
  'audio-playing': audioPlaying,
  'bell': bell,
  'bell-fill': bellFill,
  'birthday-cake': birthdayCake,
  'blur': blur,
  'board': board,
  'board-sticker-large': boardStickerLarge,
  'board-sticker-small': boardStickerSmall,
  'bold': bold,
  'border': border,
  'border-shadow': borderShadow,
  'briefcase': briefcase,
  'building-business': buildingBusiness,
  'business-hierarchy': businessHierarchy,
  'calendar': calendar,
  'calendar-check': calendarCheck,
  'camera': camera,
  'camera-flip': cameraFlip,
  'camera-roll': cameraRoll,
  'cancel': cancel,
  'canonical-pin': canonicalPin,
  'captions': captions,
  'captions-outline': captionsOutline,
  'card-stack': cardStack,
  'card-stack-refresh': cardStackRefresh,
  'check': check,
  'check-circle': checkCircle,
  'check-circle-fill': checkCircleFill,
  'chevron-down-circle': chevronDownCircle,
  'chevron-left-circle': chevronLeftCircle,
  'chevron-right-circle': chevronRightCircle,
  'chevron-up-circle': chevronUpCircle,
  'circle': circle,
  'circle-ellipsis': circleEllipsis,
  'circle-information-fill': circleInformationFill,
  'circle-initializing': circleInitializing,
  'clear': clear,
  'clipboard': clipboard,
  'clips': clips,
  'clock': clock,
  'clock-checked': clockChecked,
  'cloud-server': cloudServer,
  'code': code,
  'code-check': codeCheck,
  'cog': cog,
  'cog-fill': cogFill,
  'collage': collage,
  'collapse': collapse,
  'color': color,
  'color-palette': colorPalette,
  'color-picker': colorPicker,
  'color-solid': colorSolid,
  'color-split': colorSplit,
  'compass': compass,
  'compass-fill': compassFill,
  'compose': compose,
  'contrast': contrast,
  'conversion-tag': conversionTag,
  'copy-to-clipboard': copyToClipboard,
  'credit-card': creditCard,
  'credit-card-plus': creditCardPlus,
  'crop': crop,
  'crystal-ball': crystalBall,
  'cutout': cutout,
  'dash': dash,
  'data-source': dataSource,
  'deselect': deselect,
  'design': design,
  'desktop': desktop,
  'diagnostics': diagnostics,
  'directional-arrow-left': directionalArrowLeft,
  'directional-arrow-right': directionalArrowRight,
  'download': download,
  'drag-drop': dragDrop,
  'draw': draw,
  'dropbox': dropbox,
  'duplicate': duplicate,
  'edit': edit,
  'ellipsis': ellipsis,
  'envelope': envelope,
  'erase': erase,
  'erase-auto': eraseAuto,
  'etsy': etsy,
  'expand': expand,
  'eye': eye,
  'eye-hide': eyeHide,
  'face-happy': faceHappy,
  'face-neutral': faceNeutral,
  'face-sad': faceSad,
  'face-smiley': faceSmiley,
  'face-smiley-outline': faceSmileyOutline,
  'face-smiley-plus': faceSmileyPlus,
  'face-tryon': faceTryon,
  'facebook': facebook,
  'fade': fade,
  'ferris-wheel': ferrisWheel,
  'file-box': fileBox,
  'file-unknown': fileUnknown,
  'fill-opaque': fillOpaque,
  'fill-transparent': fillTransparent,
  'filter': filter,
  'flag': flag,
  'flame': flame,
  'flash': flash,
  'flash-automatic': flashAutomatic,
  'flash-slash': flashSlash,
  'flashlight': flashlight,
  'flip-horizontal': flipHorizontal,
  'flip-vertical': flipVertical,
  'folder': folder,
  'folder-fill': folderFill,
  'forward': forward,
  'gauge': gauge,
  'ghost': ghost,
  'ghost-fill': ghostFill,
  'gif': gif,
  'gif-visual': gifVisual,
  'gift': gift,
  'globe': globe,
  'globe-checked': globeChecked,
  'gmail': gmail,
  'graph-bar': graphBar,
  'graph-pie': graphPie,
  'hand': hand,
  'hand-pointing': handPointing,
  'handle': handle,
  'heart': heart,
  'heart-broken': heartBroken,
  'heart-health': heartHealth,
  'heart-outline': heartOutline,
  'highlights': highlights,
  'history': history,
  'home': home,
  'home-fill': homeFill,
  'idea-pin': ideaPin,
  'image-portrait': imagePortrait,
  'imessage': imessage,
  'impressum': impressum,
  'indent': indent,
  'info-circle': infoCircle,
  'information': information,
  'insights-audience': insightsAudience,
  'insights-conversion': insightsConversion,
  'instagram': instagram,
  'instagram-stories': instagramStories,
  'invoice': invoice,
  'italics': italics,
  'kakao-talk': kakaoTalk,
  'key': key,
  'knoop': knoop,
  'lab-flask': labFlask,
  'lasso-magic': lassoMagic,
  'layers-stack': layersStack,
  'layout': layout,
  'lightbulb': lightbulb,
  'lightning-bolt-circle': lightningBoltCircle,
  'link': link,
  'link-broken': linkBroken,
  'lips': lips,
  'list-bullets': listBullets,
  'list-numbered': listNumbered,
  'list-numbered-rtl': listNumberedRtl,
  'location': location,
  'lock': lock,
  'logo-large': logoLarge,
  'logo-small': logoSmall,
  'logout': logout,
  'magic-pen': magicPen,
  'magic-wand': magicWand,
  'magnifying-glass-sparkle': magnifyingGlassSparkle,
  'manage-access': manageAccess,
  'margins-large': marginsLarge,
  'margins-medium': marginsMedium,
  'margins-small': marginsSmall,
  'maximize': maximize,
  'megaphone': megaphone,
  'menu': menu,
  'messenger': messenger,
  'microphone': microphone,
  'minimize': minimize,
  'mobile': mobile,
  'moon': moon,
  'move-pin': movePin,
  'music-off': musicOff,
  'music-on': musicOn,
  'mute': mute,
  'mute-fill': muteFill,
  'orientation-landscape': orientationLandscape,
  'orientation-portrait': orientationPortrait,
  'outdent': outdent,
  'outlook': outlook,
  'overlay-text': overlayText,
  'overlay-text-outline': overlayTextOutline,
  'overview': overview,
  'paper-clip': paperClip,
  'paper-lines-plus': paperLinesPlus,
  'pause': pause,
  'pen': pen,
  'pen-auto': penAuto,
  'people': people,
  'performance-plus': performancePlus,
  'person': person,
  'person-add': personAdd,
  'person-fill': personFill,
  'person-magnifying-glass': personMagnifyingGlass,
  'phone': phone,
  'pin': pin,
  'pin-hide': pinHide,
  'pincode': pincode,
  'pinterest': pinterest,
  'play': play,
  'protect': protect,
  'qr-code': qrCode,
  'question-mark': questionMark,
  'quote': quote,
  'record-limit': recordLimit,
  'record-limit-10': recordLimit10,
  'record-limit-15': recordLimit15,
  'record-limit-30': recordLimit30,
  'record-limit-5': recordLimit5,
  'record-limit-60': recordLimit60,
  'redo': redo,
  'refresh': refresh,
  'remove': remove,
  'reorder-images': reorderImages,
  'replace': replace,
  'report': report,
  'rewind': rewind,
  'ribbon': ribbon,
  'rocketship': rocketship,
  'rotate': rotate,
  'saturation': saturation,
  'save-outline': saveOutline,
  'saved': saved,
  'scale': scale,
  'scissors': scissors,
  'search': search,
  'search-by-image': searchByImage,
  'search-fill': searchFill,
  'security': security,
  'select': select,
  'send': send,
  'shadows': shadows,
  'shapes': shapes,
  'share': share,
  'shopping-bag': shoppingBag,
  'shopping-bag-fill': shoppingBagFill,
  'shrink': shrink,
  'shuffles': shuffles,
  'skintone': skintone,
  'slide': slide,
  'smiley': smiley,
  'snapchat': snapchat,
  'sort-ascending': sortAscending,
  'sort-descending': sortDescending,
  'sound': sound,
  'sound-fill': soundFill,
  'sound-slash': soundSlash,
  'sound-slash-fill': soundSlashFill,
  'sparkle': sparkle,
  'speech': speech,
  'speech-ellipsis': speechEllipsis,
  'speech-ellipsis-fill': speechEllipsisFill,
  'speech-exclamation-point': speechExclamationPoint,
  'speech-heart': speechHeart,
  'speech-outline': speechOutline,
  'speed': speed,
  'speed-.3x': speedThirdX,
  'speed-.5x': speedFifthX,
  'speed-1x': speed1X,
  'speed-2x': speedDoubleX,
  'speed-3x': speedTripleX,
  'spread': spread,
  'square-plus': squarePlus,
  'square-plus-fill': squarePlusFill,
  'star': star,
  'star-half': starHalf,
  'star-outline': starOutline,
  'sticker': sticker,
  'sticker-image': stickerImage,
  'sun': sun,
  'swap': swap,
  'switch-account': switchAccount,
  'table': table,
  'tag': tag,
  'tag-star': tagStar,
  'target': target,
  'telegram': telegram,
  'template': template,
  'terms': terms,
  'text': text,
  'text-align-center': textAlignCenter,
  'text-align-left': textAlignLeft,
  'text-align-right': textAlignRight,
  'text-all-caps': textAllCaps,
  'text-extra-small': textExtraSmall,
  'text-invert': textInvert,
  'text-large': textLarge,
  'text-line-height': textLineHeight,
  'text-medium': textMedium,
  'text-sentence-case': textSentenceCase,
  'text-size': textSize,
  'text-small': textSmall,
  'text-spacing': textSpacing,
  'text-sticker': textSticker,
  'threads': threads,
  'thumbs-down': thumbsDown,
  'thumbs-up': thumbsUp,
  'timer': timer,
  'timer-10': timer10,
  'timer-3': timer3,
  'tint': tint,
  'trash-can': trashCan,
  'trending': trending,
  'underline': underline,
  'undo': undo,
  'unlock': unlock,
  'upload-feed': uploadFeed,
  'viber': viber,
  'vibrance': vibrance,
  'video-advance-10-seconds': videoAdvance10Seconds,
  'video-camera': videoCamera,
  'video-rewind-10-seconds': videoRewind10Seconds,
  'view-type-default': viewTypeDefault,
  'view-type-default-fill': viewTypeDefaultFill,
  'view-type-dense': viewTypeDense,
  'view-type-list': viewTypeList,
  'view-type-sparse': viewTypeSparse,
  'visit': visit,
  'warmth': warmth,
  'wave': wave,
  'whatsapp': whatsapp,
  'wifi-no': wifiNo,
  'workflow-status-all': workflowStatusAll,
  'workflow-status-canceled': workflowStatusCanceled,
  'workflow-status-halted': workflowStatusHalted,
  'workflow-status-in-progress': workflowStatusInProgress,
  'workflow-status-ok': workflowStatusOk,
  'workflow-status-problem': workflowStatusProblem,
  'workflow-status-queued': workflowStatusQueued,
  'workflow-status-unstarted': workflowStatusUnstarted,
  'workflow-status-warning': workflowStatusWarning,
  'x-social': xSocial,
  'yahoo': yahoo,
  'youtube': youtube,
});

export default icons;
